import { render, staticRenderFns } from "./card-funnel.vue?vue&type=template&id=03603eb6&scoped=true"
import script from "./card-funnel.vue?vue&type=script&lang=js"
export * from "./card-funnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03603eb6",
  null
  
)

export default component.exports